import styled, { css } from 'styled-components';

export const StyledFillingWrapper = styled.div<{ maxCapacityReached?: boolean }>`
    ${({ maxCapacityReached, theme }) =>
        maxCapacityReached &&
        css`
            div.dx-progressbar-range {
                background-color: ${theme.colors.error};
                border-color: ${theme.colors.error};
            }
        `}
`;
